module.exports = __webpack_public_path__ + "static/img/5.837d920.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/ban-de/5.jpg
// module id = Iv9g
// module chunks = 1